// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__2Lr9h","success":"FinishedQuiz_success__1kc6n","error":"FinishedQuiz_error__QZjOo"};